/* eslint-disable react/prop-types */
/* eslint-disable prefer-regex-literals */
/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useCommonInits } from 'hooks/useCommonInits';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import {
    getGroupsbyId,
    getPriceByPage,
} from 'redux/datasource/dataSourceSlice';
import {
    Typography,
    Button,
    TextField,
    Grid,
    Modal,
    Backdrop,
    Box,
} from '@mui/material';
import 'components/Modal/createModal.css';
import { savPriceReqest } from 'redux/datasource/dataSourceActions';
import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { updatePanelContent } from 'redux/panels/panelsSlice';
import { getForamttedDate } from 'utils/time';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.default',
    border: '1px solid',
    boxShadow: 24,
    p: 2,
};

export default function CreateRequestModal({
    isOpen,
    handleCloseModal,
    setPageNo,
    setSizePage,
}) {
    const [open, setOpen] = useState(false);
    const { dispatch } = useCommonInits();
    const [reqName, setReqName] = useState('');
    const [groupId, setGroupId] = useState('');
    const [groupName, setGroupName] = useState('');
    const [dateTime, setDateTime] = useState(null);
    const confirmed = 'N';
    const [newPrice, setNewPrice] = useState('');
    const [oldPrice, setOldPrice] = useState();
    const [error, setError] = useState({});
    const group_Name = useSelector(getGroupsbyId);
    const priceRequest = useSelector(getPriceByPage);
    const [errMsg, setErrMsg] = useState(false);
    const [errMsg1, setErrMsg1] = useState(false);
    const [errosMsg, setErrorMsg] = useState(false);
    const [reqErrMsg, setReqErrMsg] = useState(false);
    const regex = new RegExp(/^\d{1,3}(?:\.\d{1,2})?$/);
    const reqRegex = new RegExp('^[1-9a-zA-Z][0-9a-zA-Z_]*$');
    
    const isReqNameValid = reqRegex.test(reqName) && reqName?.length <= 30;
    const isOldValueValid =
        !oldPrice || (regex.test(oldPrice) && oldPrice <= 150);
    const isNewValueValid = regex.test(newPrice) && newPrice <= 150;

    useEffect(() => {
        setOpen(isOpen);
    }, [isOpen]);

    useEffect(() => {
        setGroupId(group_Name._id);
        setGroupName(group_Name.name);
        if (priceRequest) {
            setOldPrice(priceRequest[0]?.price );
        }
    }, []);

   
    const handleDataChange = () => {
        dispatch(
            updatePanelContent({
                reqName,
                oldPrice,
                newPrice,
                confirmed,
                dateTime: dateTime !== null ? getForamttedDate(dateTime) : null,
            }),
        );
        if (isReqNameValid) {
            setReqErrMsg(false);
        }
        if (isOldValueValid) {
            setErrMsg(false);
        }
        if (isNewValueValid) {
            setErrMsg1(false);
        }
    };

    const saveRequest = () => {
        if (dateTime === null) {
            setErrorMsg(true);
        }
        setError({
            reqName: !reqName,
            newPrice: !newPrice,
        });
        if (
            dateTime !== null &&
            newPrice &&
            isOldValueValid &&
            isReqNameValid &&
            isNewValueValid
        ) {
            const params = {
                group_id: groupId,
                group_name: groupName,
                price_request_name: reqName,
                old_price: oldPrice,
                price: newPrice,
                confirmed: 'N',
                executed: 'N',
                executed_by: '',
                date_time:
                    dateTime !== null ? getForamttedDate(dateTime) : null,
                page_no: setPageNo,
                no_of_records: setSizePage,
            };
            dispatch(savPriceReqest(params));
            handleDataChange();
            handleClose();
        } else {
            if (!isReqNameValid) {
                setReqErrMsg(true);
            }
            if (!isOldValueValid) {
                setErrMsg(true);
            }
            if (!isNewValueValid) {
                setErrMsg1(true);
            }
        }
    };
    const handleClose = () => {
        setOpen(false);
        handleCloseModal();
    };

    const renderRequest = () => (
            <>
                <TextField
                    variant="outlined"
                    size="small"
                    label='Request Name'
                    type="string"
                    sx={{ width: '100%', marginTop: '10px' }}
                    value={reqName || ''}
                    inputProps={{
                        maxLength: 31,
                    }}
                    error={error.reqName}
                    onChange={e => setReqName(e.target.value)}
                    onBlur={handleDataChange}
                />
                {reqErrMsg && (
                    <span style={{ color: 'red', marginTop: '-20px' }}>
                        Only alphabets,numbers & '_' are allowed & you can enter only upto 30
                        maximum letters
                    </span>
                )}
                {!priceRequest.length ? (
                    <TextField
                        variant="outlined"
                        size="small"
                        label='Old Price'
                        type="number"
                        sx={{ width: '100%' }}
                        style={{marginTop: '35px'}}
                        value={oldPrice || ''}
                        onChange={e => setOldPrice(parseFloat(e.target.value))}
                        onBlur={handleDataChange}
                    />
                ) : (
                    <TextField
                        variant="outlined"
                        size="small"
                        label='Old Price'
                        type="number"
                        sx={{ width: '100%' }}
                        style={{marginTop: '35px'}}
                        value={oldPrice || ''}
                        //   onChange={e => setOldPrice(e.target.value)}
                        onBlur={handleDataChange}
                    />
                )}
                {errMsg && (
                    <label style={{ color: 'red' }}>
                        Maximum value is 150 with up to 2 decimal places like
                        '90.08'
                    </label>
                )}
                <TextField
                    variant="outlined"
                    size="small"
                    label='New Price'
                    type="number"
                    sx={{ width: '100%' }}
                    style={{ marginTop: '35px'}}
                    value={newPrice || ''}
                    error={error.newPrice}
                    onChange={e => setNewPrice(parseFloat(e.target.value))}
                    onBlur={handleDataChange}
                />
                {errMsg1 && (
                    <label style={{ color: 'red' }}>
                        Maximum value is 150 with up to 2 decimal places like
                        '90.08'
                    </label>
                )}
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DesktopDateTimePicker
                        label="Select Date and Time"
                        value={
                            dateTime !== null
                                ? getForamttedDate(dateTime)
                                : null
                        }
                        onChange={newValue => setDateTime(newValue)}
                        onBlur={handleDataChange}
                        error={error.dateTime}
                        renderInput={params => (
                            <TextField
                                {...params}
                                size="small"
                                sx={{ width: '465px', marginTop: '35px' }}
                            />
                        )}
                    />
                </LocalizationProvider>
                {errosMsg && (
                    <label style={{ color: '#E52414' }}>
                        Please Select Date and Time.
                    </label>
                )}
            </>
        );

    return (
        <div>
            <Modal
                aria-labelledby="spring-modal-title"
                aria-describedby="spring-modal-description"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Box sx={style}>
                    <Grid container>
                        <Grid item xs={10}>
                            <Typography
                                id="spring-modal-title"
                                variant="h6"
                                component="h2"
                            >
                                Create Request
                            </Typography>
                        </Grid>
                        <Grid
                            item
                            sx={{
                                position: 'absolute',
                                right: '5px',
                                top: '5px',
                            }}
                        >
                            <IconButton onClick={handleClose}>
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                    {renderRequest()}
                    <Grid
                        item
                        sx={{ display: 'flex', justifyContent: 'flex-end' }}
                    >
                        <Button
                            variant="outlined"
                            sx={{ mt: 2, mr: 2 }}
                            onClick={handleClose}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="outlined"
                            sx={{ mt: 2, mr: 2 }}
                            onClick={saveRequest}
                        >
                            Create
                        </Button>
                    </Grid>
                </Box>
            </Modal>
        </div>
    );
}
